export default "__VITE_ASSET__d8372373__"